<!-- eslint-disable max-len -->
<template>
  <div
    style="display: flex; flex-direction: row; width: 100%; border-top: 1px solid #818C97; background-color: #F7F8FA;"
    class="dashboard"
  >
    <div :style="`display: flex; flex-direction: column; width: ${showRightPanel ? '95%' : '100%'}`">
      <div
        id="content"
        style="width: 100%"
      >
        <grid-layout
          ref="gridlayout"
          :layout.sync="layout"
          :colNum="gridColNumber"
          :isDraggable="true"
          :isResizable="true"
          :verticalCompact="true"
          :responsive="false"
          :useCssTransforms="true"
        >
          <grid-item
            v-for="item in layout"
            :key="item.i"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :minH="item.minH"
            :minW="item.minW"
            @moved="movedEvent"
            @resized="resizedEvent"
          >
            <div class="content-widget">
              <WidgetBox
                :widget="item"
                :w="item.w"
                :h="item.h"
                :minH="item.minH"
                :minW="item.minW"
                @close="deleteItem"
                @updateWidgetInLayout="updateWidgetInLayout"
              />
            </div>
          </grid-item>
        </grid-layout>
      </div>
    </div>


    <div
      class="right-panel"
      :style="{'--min-width': showRightPanel ? '150px' : '40px'}"
    >
      <div class="right-panel-header">
        <div
          v-if="showRightPanel"
          style="color: #fff; font-weight: 600; font-size: 16px; letter-spacing: 0.5px;"
        >
          {{ $t('siteDashboard.widgets') }}
        </div>
        <v-img
          v-else
          src="@/assets/images/bxs_widget.svg"
        />
      </div>
      <div class="right-panel-toggle">
        <v-img
          v-if="showRightPanel"
          src="@/assets/images/arrow-right.svg"
          @click="showRightPanel = false"
        />
        <v-img
          v-else
          src="@/assets/images/arrow-left.svg"
          @click="showRightPanel = true"
        />
      </div>
      <div
        v-if="showRightPanel"
        style="padding: 5px"
      >
        <div
          v-for="item in dashBoardType"
          :key="item.id"
          class="droppable-element"
          draggable="true"
          unselectable="on"
          @drag="drag(item)"
          @dragend="(e) => dragend( e,item)"
        >
          <WidgetType
            :widgetName="item.name"
            :widgetIconName="item.icon"
            :widgetDescription="item.description"
            :widgetIconColor="item.color"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout';
import { mapGetters } from 'vuex';
import { TEMPLATE_TYPES } from '@/aquassist-shared/constants/dashboard';
import WidgetType from './components/WidgetType.vue';
import WidgetBox from './components/WidgetBox.vue';

const mouseXY = { x: null, y: null };
const DragPos = { x: null, y: null, w: 1, h: 1, i: null, minH: null, maxH: null };


export default {
    components: {
        GridLayout,
        GridItem,
        WidgetType,
        WidgetBox,
    },
    data() {
        return {
            layout: [],
            memberId: this.$route.params.memberId,
            showRightPanel: false,
            widthScreen: window.innerWidth,
        };
    },

    computed: {
        ...mapGetters([
            'currentMember',
            'site',
        ]),
        dashBoardType() {
            return TEMPLATE_TYPES.filter(template => !this.layout.some(widget => widget.name === template.name));
        },
        kindOfDevice() {
            if (this.$vuetify.breakpoint.xs) {
                return 'mobile'; // < 600px
            } if (this.$vuetify.breakpoint.sm) {
                return 'tablet'; // 600px - 959px
            } if (this.$vuetify.breakpoint.md) {
                return 'desktop'; // 960px - 1263px
            }
            return 'desktop-large'; // >= 1264px
        },
        gridColNumber() {
            if (this.kindOfDevice === 'desktop-large') {
                return 10;
            } if (this.kindOfDevice === 'desktop') {
                return 8;
            } if (this.kindOfDevice === 'tablet') {
                return 4;
            }
            return 2;
        },
        widgetTitle() {
            return this.widget.name.charAt(0).toLowerCase() + this.widget.name.slice(1) || '';
        },
    },
    watch: {
        kindOfDevice(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.recalculateLayout();
            }
        },
    },

    created() {
        document.addEventListener('dragover', e => {
            mouseXY.x = e.clientX;
            mouseXY.y = e.clientY;
        }, false);
        this.getLayout();
    },


    methods: {
        drag(e) {
            const parentRect = document.getElementById('content').getBoundingClientRect();
            let mouseInGrid = false;
            if (((mouseXY.x > parentRect.left)
                  && (mouseXY.x < parentRect.right))
                  && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
                mouseInGrid = true;
            }
            if (mouseInGrid === true && (this.layout.findIndex(item => item.i === 'drop')) === -1) {
                this.layout.push({
                    x: (this.layout.length * 2) % (this.colNum || 12),
                    y: this.layout.length + (this.colNum || 12), // puts it at the bottom
                    w: e.w,
                    h: e.h,
                    i: 'drop',
                    name: e.name,
                    minW: e.minW,
                    minH: e.minH,
                });
            }
            const index = this.layout.findIndex(item => item.i === 'drop');

            if (index !== -1) {
                try {
                    this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = 'none';
                // eslint-disable-next-line no-empty
                } catch {
                }

                const el = this.$refs.gridlayout.$children[index];
                el.dragging = { top: mouseXY.y - parentRect.top, left: mouseXY.x - parentRect.left };
                const newPosition = el.calcXY(mouseXY.y - parentRect.top, mouseXY.x - parentRect.left);
                if (mouseInGrid === true) {
                    this.$refs.gridlayout.dragEvent('dragstart', 'drop', newPosition.x, newPosition.y, 1, 1);
                    DragPos.i = String(index);
                    DragPos.x = this.layout[index].x;
                    DragPos.y = this.layout[index].y;
                }
                if (mouseInGrid === false) {
                    this.$refs.gridlayout.dragEvent('dragend', 'drop', newPosition.x, newPosition.y, 1, 1);
                    this.layout = this.layout.filter(obj => obj.i !== 'drop');
                }
            }
        },
        dragend(e, item) {
            const parentRect = document.getElementById('content').getBoundingClientRect();
            let mouseInGrid = false;
            if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right))
                && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
                mouseInGrid = true;
            }
            if (mouseInGrid === true) {
                this.$refs.gridlayout.dragEvent('dragend', 'drop', DragPos.x, DragPos.y, 1, 1);
                this.layout = this.layout.filter(obj => obj.i !== 'drop');
                this.layout.push({
                    x: DragPos.x,
                    y: DragPos.y,
                    w: item.w,
                    h: item.h,
                    i: Math.max(...this.layout.map(layoutItem => Number(layoutItem.i)), 0) + 1,
                    name: item.name,
                    minH: item.minH,
                    minW: item.minW,
                });
                try {
                    this.$refs.gridlayout.dragEvent('dragend', DragPos.i, DragPos.x, DragPos.y, 1, 1);
                    this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = 'block';
                    // eslint-disable-next-line no-empty
                } catch {
                }
            }
        },
        deleteItem(i) {
            this.layout = this.layout.filter(obj => obj.i !== i);
        },
        async saveLayout(layout = this.layout) {
            const isValid = this.layout && this.layout.every(item => typeof item.i === 'number');
            if (isValid) {
                await this.$rq.dashboardSaveLayout(this.currentMember.id, this.site.id, layout);
            }
        },
        async getLayout() {
            const { data } = await this.$rq.dashboardGetLayout(this.currentMember.id, this.site.id);
            this.layout = data;
        },
        recalculateLayout() {
            this.layout.forEach(item => {
                // eslint-disable-next-line no-param-reassign
                item.x = Math.min(item.x, this.gridColNumber - item.w); // Évite les dépassements
            });
            this.$nextTick(() => {
                this.$forceUpdate(); // Force la mise à jour du DOM
            });
        },
        // for updating service call widget
        async updateWidgetInLayout(widget) {
            // assignment of layout will trigger layout watch
            this.layout = this.layout.map(obj => (obj.i === widget.i ? widget : obj));
            this.saveLayout();
        },
        movedEvent(i, newX, newY) {
            this.layout = this.layout.map(item => (item.i === i ? { ...item, x: newX, y: newY } : item));
            this.saveLayout();
        },
        resizedEvent(i, newX, newY) {
            this.layout = this.layout.map(item => (item.i === i ? { ...item, x: newX, y: newY } : item));
            this.saveLayout();
        },
    },
};
</script>

<style scoped>

.vue-grid-layout {
  width: 100%;
  }

.vue-grid-item:not(.vue-grid-placeholder) {
  border: 3px solid #E7EAEF;
  border-radius: 15px;
  background-color:#E7EAEF;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.columns {
  -moz-columns: 120px;
  -webkit-columns: 120px;
  columns: 120px;
}

.right-panel {
  border-left : 1px solid #818C97;
  min-width: var(--min-width);
  margin-left: 20px;
}
.droppable-element {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 10px;
  height: 150px;
  border: 3px solid #E7EAEF;
  border-radius: 15px;
  background-color: white;
  text-align: center;
  padding: 10px;
}

.itemDashboard {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.subTitle{
  margin-top : 10px;
  margin-left: 20px;
}

#content {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 150px);
}


.buttonWidget {
  border: 0;
  color: black;
  font-weight: bold;
  padding: 7px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 25px;
}
</style>

<style lang="scss">
@import "@/assets/styles/utils/_variables.scss";

.dashboard {
  .vue-grid-item   {
    background-color: $primary-color;
  }
  .vue-grid-layout {
    height : 100%;
  }
}
.content-widget{
  display:flex;
  flex-direction: column;
  height: 100%;
}
.right-panel-header {
  display:flex;
  justify-content: center;
  align-items: center;
  background-color: #26384B;
  height:60px;
  padding: 5px;
}
.right-panel-toggle {
  position: fixed;
  top: 56%;
  margin-left: -15px;
}
.vue-grid-item.vue-grid-placeholder {
  background: gray !important;
}
</style>

<style lang="scss">
@import "@/assets/styles/utils/_variables.scss";

.dashboard {
  .vue-grid-item   {
    background-color: $primary-color;
  }
  .vue-grid-layout {
    height : 100%;
  }
}
.content-widget{
  display:flex;
  flex-direction: column;
height: 100%;
}
</style>
